module.exports = __webpack_public_path__ + "img/img_03.8826a815.png";